import React from 'react';

const FinalCTA = () => {
  return (
    <section
      className="bg-[#0F172A] py-24 text-center"
      style={{
        background:
          'radial-gradient(ellipse at center, rgba(59,130,246,0.15) 0%, #0F172A 70%)',
      }}
    >
      <div className="max-w-3xl mx-auto px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-white">
          Ready to Simplify Your Fleet?
        </h2>
        <p className="text-lg text-gray-400 mt-4">
          Join 500+ fleets already saving hours every week.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
          <a
            href="/auth/register"
            className="px-8 py-3 rounded-lg font-semibold text-white bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 transition-all duration-200 shadow-lg shadow-blue-500/25"
          >
            Start Free Trial
          </a>
          <a
            href="/auth/login"
            className="px-8 py-3 rounded-lg font-semibold text-white border border-white/20 hover:border-white/40 hover:bg-white/5 transition-all duration-200"
          >
            Schedule a Demo
          </a>
        </div>

        <p className="text-sm text-gray-500 mt-6">
          No credit card · 14-day free trial · Cancel anytime
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
